import React,{useState,useContext} from 'react'
import axios from '../api/axios';
import config from '../api/config'
axios.defaults.withCredentials = true
const SettingContext=React.createContext();

export function useSettings(){
    return useContext(SettingContext)
}

export function SettingContextprovider({children}){
const[settingData,setSettingData]=useState({})

const getSettingByName=async(settingName)=>{
    
        await axios.get('/settings/'+settingName).then(res=>{
            let oldSettings=settingData
            
            setSettingData({...oldSettings,[settingName]:res.data[0].info})

        } )
        .catch(error=> console.log(`Error: $error`));
}

const getUserSettings=async()=>{
    
        await axios.get('/settings/').then(res=>{
            setSettingData(res.data)
        } )
        .catch(error=> console.log(`Error: $error`));
    }
 
    const value={
        getSettingByName,
        settingData
    }

    return (
        <SettingContext.Provider value={value}>
            {children}
        </SettingContext.Provider>
    )
}

export default SettingContextprovider;